import React from 'react';
import SeverityDescription from './SeverityDescription';

const SeverityLevel = ({ level, text }) => {
	return (
		<div className={'severity-level'}>
			<span className={`severity-level__indicator level-${level}`} />
			<span className="severity-level__text">{text ? <span>{text}</span> : <SeverityDescription level={level} />}</span>
		</div>
	);
};

export default SeverityLevel;
